import { render, staticRenderFns } from "./tableRecycle.vue?vue&type=template&id=036ca127&scoped=true&"
import script from "./tableRecycle.vue?vue&type=script&lang=js&"
export * from "./tableRecycle.vue?vue&type=script&lang=js&"
import style0 from "./tableRecycle.vue?vue&type=style&index=0&id=036ca127&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ca127",
  null
  
)

export default component.exports